import React, { Component } from "react";
import ProfileBase from "./helpers/ProfileBase";
import EducationBox from "./helpers/EducationBox";
import SamplesBox from "./helpers/SamplesBox";
import RemoteSamplesBox from "./helpers/RemoteSamplesBox";
import TopExperienceBox from "./helpers/TopExperienceBox";
import AdditionalTalentNotesBox from "./helpers/AdditionalTalentNotesBox";
import DirectorsCommentsBox from "./helpers/DirectorsCommentsBox";

class VoiceActorProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ProfileBase
        profileUrlPart="voiceactor"
        render={(profileData) => (
          <div>
            {profileData.ProfileType === "VoiceActor" && (
              <div>
                <div className="row">
                  <div className="col-md-6 widget">
                    <div className="title">Experience</div>
                    <div className="row">
                      <div className="col">
                        <div className="row">
                          <div className="col-4">Voice age:</div>
                          <div className="col-8">{profileData.VoiceAges}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Voice type:</div>
                          <div className="col-8">{profileData.VoiceTypes}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Voice gender:</div>
                          <div className="col-8">
                            {profileData.LiveActionVoiceGenders} (L/A)
                            <br />
                            {profileData.AnimationVoiceGenders} (Animation)
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-4">Language accent:</div>
                          <div className="col-8">{profileData.LanguageAccents}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Productions:</div>
                          <div className="col-8">{profileData.ExperienceProductions}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Genres:</div>
                          <div className="col-8">{profileData.ExperienceGenres}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Additional experience:</div>
                          <div className="col-8">{profileData.Experience}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Studios:</div>
                          <div className="col-8">{profileData.LocalizationCompanies}</div>
                        </div>
                        <div className="row">
                          <div className="col-4">Clients:</div>
                          <div className="col-8">{profileData.ProductionContentOwners}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <EducationBox schools={profileData.Schools} />
                </div>
                <div className="row">
                  <AdditionalTalentNotesBox additionalNotes={profileData.AdditionalNotes} />
                  <TopExperienceBox experiences={profileData.ExternalExperiences} />
                </div>
                <div className="row">
                  <SamplesBox profileData={profileData} skillVendorId={this.props.skillvendorId} classColumn={"col-md-6"} />
                  <RemoteSamplesBox profileData={profileData} classColumn={"col-md-6"} talent={true} />
                </div>
                <div className="row">
                  <DirectorsCommentsBox skillVendorId={this.props.skillvendorId} directorsComments={profileData.DirectorsComments} classColumn={"col-md-6"} />
                </div>
              </div>
            )}
          </div>
        )}
      />
    );
  }
}

export default VoiceActorProfile;
